import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import { ScrollingModule as ExperimentalScrollingModule} from '@angular/cdk-experimental/scrolling';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

@NgModule({
  imports: [
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatInputModule,
    MatFormFieldModule,
    DragDropModule,
    MatChipsModule,
    MatExpansionModule,
    MatSelectModule,
    MatMenuModule,
    MatDialogModule,
    MatRadioModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatListModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    ScrollingModule,
    MatButtonToggleModule,
    ClipboardModule,
    MatTabsModule,
    MatProgressBarModule,
    MatCardModule,
    MatBadgeModule,
    MatMomentDateModule
  ],
  exports: [
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatInputModule,
    MatFormFieldModule,
    DragDropModule,
    MatChipsModule,
    MatExpansionModule,
    MatSelectModule,
    MatMenuModule,
    MatDialogModule,
    MatRadioModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatListModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    ScrollingModule,
    MatButtonToggleModule,
    ClipboardModule,
    MatTabsModule,
    MatProgressBarModule,
    MatCardModule,
    MatBadgeModule,
  ],
  providers: [MatDatepickerModule, { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }],
})
export class MaterialModule {}
